import React, { useCallback } from 'react';
import _get from 'lodash/get';

import { useModalStore } from 'bdvp-common/src/hooks/store';
import {
    useBasePath,
    useLang,
    useAppView,
    useMediaConfig,
} from 'bdvp-common/src/hooks/config';
import { MEDIA_CONFIG_CONTEXT } from 'bdvp-common/src/utils/constants';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import useSearchQueryParam from '../hooks/store/useSearchQueryParam';
import useSearchQuery from '../hooks/store/useSearchQuery';
import useSearchSort from '../hooks/store/useSearchSort';
import { FALLBACK_SORT } from '../utils/constants';
import Results from '../components/SearchResults';

const {
    LIGHTBOX_MODAL_NAME,
    SHARE_MODAL_NAME,
} = modalConstants;

const SearchResults = () => {

    const {
        loading,
        data,
        error,
        loadingMore,
        fetchMoreData,
        page,
        contentPreference,
    } = useSearchQuery();
    const { searchQuery, queryType } = useSearchQueryParam();
    const lang = useLang();
    const basePath = useBasePath();
    const config = useMediaConfig(MEDIA_CONFIG_CONTEXT.search);
    const {
        modalShow,
        modalHide,
        isModalOpen,
    } = useModalStore();
    const {
        setSearchSort,
        isSorting,
        setIsSorting,
        searchSortSelectedOption,
    } = useSearchSort();

    const openLightbox = useCallback(()=> {

        modalShow(LIGHTBOX_MODAL_NAME);

    }, [modalShow]);

    const closeLightbox = useCallback(()=> {

        modalHide(LIGHTBOX_MODAL_NAME);

    }, [modalHide]);

    const isShareModalOpen = isModalOpen(SHARE_MODAL_NAME);

    const resetSort = useCallback(()=> {

        setSearchSort(_get(config, 'sortOptions[0].value', FALLBACK_SORT));

    }, [
        setSearchSort,
        config,
    ]);

    const appView = useAppView();

    return (
        <Results
            appView={appView}
            basePath={basePath}
            loading={loading}
            data={data}
            error={error}
            lang={lang}
            page={page}
            loadingMore={loadingMore}
            basePath={basePath}
            fetchMoreData={fetchMoreData}
            openLightbox={openLightbox}
            closeLightbox={closeLightbox}
            isShareModalOpen={isShareModalOpen}
            searchQuery={searchQuery}
            resetSort={resetSort}
            isSorting={isSorting}
            setIsSorting={setIsSorting}
            searchSortSelectedOption={searchSortSelectedOption}
            contentPreference={contentPreference}
            queryType={queryType}
        />
    );

};

export default SearchResults;
